import { Grid, Typography, Switch, Divider } from "@material-ui/core";
import { PrimaryButton } from "../components-atoms";
import GeneralModal from "./GeneralModal";
import { useState } from "react";
import { colours } from "../constants/theme";
import { getShopDetail, shopTogglePremium, shopTogglePremiumOnly } from "../redux/actions/subscriptions";

interface SubscriptionActivateModalProps {
  isVisible: boolean;
  close: () => void;
  shopId?: string;
  premiumEnabled?: boolean;
  premiumOnly?: boolean;
}

export function SubscriptionUpdatePremiumModal({ isVisible, close, shopId, premiumEnabled, premiumOnly }: SubscriptionActivateModalProps): JSX.Element {
  const [_premiumEnabled, setPremiumEnabled] = useState(premiumEnabled);
  const [_premiumOnly, setPremiumOnly] = useState(premiumOnly);

  function getShopData() {
    getShopDetail(
      shopId,
      (res) => {
        setPremiumEnabled(res.PremiumEnabled);
        setPremiumOnly(res.PremiumOnly);
      },
      (err) => { /* Removed console.log */ },
    );
  }

  const togglePremium = () => {
    if (!shopId) return null;
    shopTogglePremium(shopId, () => {
      getShopData();
    }, () => { });
  }

  const togglePremiumOnly = () => {
    if (!shopId) return null;
    shopTogglePremiumOnly(shopId, () => {
      getShopData();
    }, () => { });
  }
  return (
    <GeneralModal
      title="Update Concierge Preferences"
      description="Update the concierge preferences for this subscription."
      visible={isVisible}
      onClose={() => close()}
      modalWidth="560px"
    >
      <GeneralModal.ContentArea>
        <Grid container>
          <Grid container item xs={12} style={{ margin: "24px 0 0 0" }}>
            <Grid item xs>
              <Typography variant="body2">
                Concierge Enabled
              </Typography>
            </Grid>
            <Grid item>
              <Switch
                color="primary"
                checked={_premiumEnabled}
                onChange={togglePremium}
              />
            </Grid>
          </Grid>
          <Divider style={{ width: '100%', margin: '8px 0', background: colours.dark08 }} />
          <Grid container item xs={12} style={{ margin: "12px 0 24px 0" }}>
            <Grid item xs>
              <Typography variant="body2">
                Don't show individual quotes
              </Typography>
            </Grid>
            <Grid item>
              <Switch
                color="primary"
                checked={_premiumOnly}
                onChange={togglePremiumOnly}
              />
            </Grid>
          </Grid>
        </Grid>
      </GeneralModal.ContentArea>
      <GeneralModal.ButtonArea>
        <PrimaryButton
          title="Done"
          onClick={() => close()}
        />
      </GeneralModal.ButtonArea>
    </GeneralModal>
  );
}
